import disease_clingen from "./details6.disease_clingen"
import { gene2pheno_disease } from "./details6.gene2pheno_disease"
import { phenotype_information } from "./details6.phenotype_information"

const externalFilters = {
    "details6.gene2pheno_disease": gene2pheno_disease,
    "details6.disease_clingen": disease_clingen,
    "details6.phenotype_information": phenotype_information
}

export default externalFilters